export default async function (promotion, receipt) {
  if(typeof promotion.options.text === "string") {
    const text = promotion.options.text.trim()
    if(text !== "") {
      receipt.announcements.push({ text })
    }
  }
}
